import useBaseRequest from "../../api/BaseRequest";
import DocumentGateway from "../../api/gateways/DocumentGateway";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "../../store/auth/AuthSelectors";
import DigitalSignatureQualifiedGateway from "../../api/gateways/DigitalSignatureQualifiedGateway";
import { useToast } from "../../components/toast";

const buildQuery = (search: string) => {
  const params = new URLSearchParams(search);
  if (!params.has("limit")) params.set("limit", "21");
  return "?" + params.toString();
};

export const useDigitalSignatureQualified = () => {
  const user = useUser();
  const { success, danger } = useToast();
  const location = useLocation();
  const { data, execute, loading } = useBaseRequest(DocumentGateway.getQdsSignatureDocuments);

  useEffect(() => {
    if (user) {
      execute(buildQuery(location.search));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, location.search]);

  const [selectedId, setSelectedId] = useState<number>();

  const { execute: deleteQdsRequest, loading: deletingSignature } = useBaseRequest(
    DigitalSignatureQualifiedGateway.deleteQdsRequest,
    {
      onCompleted: () => {
        success("Qualified Digital Signature Request deleted successfully.");
        closeDeleteModal();
        execute(buildQuery(location.search));
      },
      onError: (error: any) => {
        const message = error?.message || "Failed to delete Qualified Digital Signature Request.";
        danger(message);
      },
    }
  );

  const closeDeleteModal = () => setSelectedId(undefined);
  const onStartDelete = (id: number) => setSelectedId(id);
  const onDelete = () => {
    if (selectedId) deleteQdsRequest(selectedId);
  };
  const onResend = (id: number) => {};

  return {
    documents: data?.documents || [],
    count: data?.count || 0,
    deletingSignature,
    closeDeleteModal,
    showDeleteModal: selectedId !== undefined,
    loading,
    onDelete,
    onStartDelete,
    onResend,
  };
};
